import { render, staticRenderFns } from "./permission-list-item.vue?vue&type=template&id=53825914"
import script from "./permission-list-item.vue?vue&type=script&lang=js"
export * from "./permission-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53825914')) {
      api.createRecord('53825914', component.options)
    } else {
      api.reload('53825914', component.options)
    }
    module.hot.accept("./permission-list-item.vue?vue&type=template&id=53825914", function () {
      api.rerender('53825914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/security-group/user-binding/permission-list-item.vue"
export default component.exports